export default __webpack_public_path__ + "static/media/step_002.952a49e8.jpeg";